import isNil from 'lodash/isNil'

export const key = 'axis'

export const process = (chart, config) => {
  const isArr = Array.isArray(config)

  // 不渲染坐标轴
  if (isNil(config) || config === false || (isArr && config.length === 0)) {
    return chart.axis(false)
  }

  if (config === true) {
    return chart.axis(true)
  }

  const arrAxis = isArr ? config : [config]
  arrAxis.forEach((res) => {
    if (res.dataKey) {
      if (res.show === false) {
        chart.axis(res.dataKey, false)
      } else {
        const { show, dataKey, ...options } = res
        chart.axis(res.dataKey, options)
      }
    } else {
      chart.axis(res)
    }
  })
  return chart
}
